import { useEffect, useState } from "react";
import { fetchEnvironment as fetchEnvironmentRequest } from "../services/auth.service";

const getAppTitle = (environment: string): string => {
    switch (environment) {
        case "local":
            return "ProspoAI Local";
        case "development":
            return "ProspoAI Dev";
        case "uat":
            return "ProspoAI UAT";
        case "production":
            return "ProspoAI";
        default:
            return "ProspoAI";
    }
};

/**
 * Returns the environment-qualified app title (e.g. "ProspoAI Dev") for use as the
 * default document title. Callers render this via <Helmet> rather than setting
 * document.title directly, so it participates in Helmet's title stack instead of
 * clobbering (or being clobbered by) per-page titles.
 */
export const useEnvironmentTitle = (): string => {
    const [title, setTitle] = useState("ProspoAI");

    useEffect(() => {
        const fetchEnvironment = async () => {
            try {
                const response: any = await fetchEnvironmentRequest();
                if (response.success && response.environment) {
                    setTitle(getAppTitle(response.environment));
                }
            } catch (error) {
                console.error("Failed to fetch environment:", error);
                // Keep default title on error
            }
        };

        fetchEnvironment();
    }, []);

    return title;
};
